var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfaction6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:4.2;stroke-miterlimit:10;}\n\t.st1{font-family:'BerlinSansFBDemi-Bold';}\n\t.st2{font-size:50px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M141.9,80.4h-20.3c-1.2,0-2.2,1-2.2,2.2v3.2h-5.6l-9.6-6.9c-0.3-0.2-0.7-0.4-1-0.7c0.4,1,0.6,1.9,0.6,2.9 c0,0.9-0.1,1.8-0.4,2.6l8.4,6c0.4,0.3,0.8,0.4,1.3,0.4l0,0h6.3v21.6h-5.5c-0.6,0-1.2,0.2-1.6,0.7l-11.5,11.9 c1.3,0.7,2.6,1.5,3.7,2.5l10.3-10.7h4.6v2c0,1.2,1,2.2,2.2,2.2h20.3c1.2,0,2.2-1,2.2-2.2V82.6C144.1,81.4,143.1,80.4,141.9,80.4z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,136.2c-0.8,0-1.4-0.6-1.4-1.4V21.2c0-0.8,0.6-1.4,1.4-1.4h73.4c0.8,0,1.4,0.6,1.4,1.4v16.5 c1.4-0.5,2.9-0.7,4.4-0.6V21.2c0-3.2-2.6-5.8-5.8-5.8H17.7c-3.2,0-5.8,2.6-5.8,5.8v113.7c0,3.2,2.6,5.8,5.8,5.8h68.5 c0.5-1,1.1-1.9,1.9-2.6c-1.1-0.4-2.1-1-2.9-1.8H17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,71.7h52c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2h-52c-1.2,0-2.2,1-2.2,2.2C26.2,70.7,27.2,71.7,28.4,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,89.3h28.8c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H28.4c-1.2,0-2.2,1-2.2,2.2C26.2,88.3,27.2,89.3,28.4,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,106.9h22.9c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H28.4c-1.2,0-2.2,1-2.2,2.2C26.2,105.9,27.2,106.9,28.4,106.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4,124.5h26c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2h-26c-1.2,0-2.2,1-2.2,2.2C26.2,123.5,27.2,124.5,28.4,124.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.7,122.1c-4.6-0.2-9.2-0.3-13.8-0.5c-1.3,0-2.6,1.2-2.5,2.5c0.1,1.4,1.1,2.5,2.5,2.5c4.6,0.2,9.2,0.3,13.8,0.5 c1.3,0,2.6-1.2,2.5-2.5C105.1,123.2,104.1,122.2,102.7,122.1L102.7,122.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.8,80.2c-2.5-4.1-5.3-8.5-5.8-13.5c-0.5-5.3,0.7-10.6-0.7-15.8c-0.6-2.2-1.7-4.7-4.2-5.3c-2.8-0.6-4.9,1.4-6.4,3.5 c-2.8,3.9-4.6,8.5-5.5,13.2c-1.1,5.7-0.9,11.4,0,17.1c0.2,1.3,1.9,2.1,3.1,1.7c1.4-0.4,2-1.7,1.7-3.1c-1.3-8-0.7-16.8,3.5-24 c0.5-0.8,1-1.7,1.6-2.4c0.2-0.3,0.5-0.5,0.7-0.8c0.1-0.2,0.5-0.3,0.2-0.3c-0.3,0-0.1-0.1,0,0.2c0.1,0.4,0.3,0.7,0.4,1.1 c0.3,1,0.5,2,0.6,3.1c0.4,4.7-0.4,9.4,0.4,14.1c0.9,5,3.6,9.5,6.2,13.7C103.1,85.4,107.4,82.9,105.8,80.2L105.8,80.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.4,78c-3.2,0.3-6.4,0.6-9.7,0.9c-3.1,0.3-6.1,0.8-8.5,3c-2,1.8-3.2,4.9-2.2,7.5c1,2.8,4,4.7,6.9,3.8 c-0.8-1.4-1.6-2.8-2.4-4.2c-2.6,2.2-4.2,5.6-3.6,9c0.6,3.3,3.3,5.8,6.6,5.9c-0.4-1.6-0.8-3.1-1.3-4.7c-2.6,1.9-4,5.2-3.1,8.4 c0.9,3.1,3.9,5.2,7.1,5.3c-0.2-1.6-0.4-3.3-0.7-4.9c-5.3,2-5.2,8.2-2.5,12.3c1.5,2.3,3.3,3.4,6,4c2.7,0.6,5.4,1.3,8.2,1.9 c3.1,0.7,4.5-4.1,1.3-4.8c-1.9-0.4-3.7-0.9-5.6-1.3c-0.9-0.2-1.9-0.4-2.8-0.7c-0.6-0.2-1.4-0.3-1.9-0.7c-1-0.8-1.9-2.6-2.1-3.9 c-0.1-0.6,0.1-1.9,0.8-2.1c1.2-0.4,2-1.4,1.8-2.7c-0.2-1.2-1.2-2.2-2.5-2.2c-2.1,0-3.3-3-1.5-4.3c2-1.4,1.3-4.5-1.3-4.7 c-1.1-0.1-1.7-1.4-1.8-2.3c-0.1-1.7,1.1-3.1,2.3-4.1c1.9-1.6-0.1-4.9-2.4-4.2c-0.7,0.2-1.1-0.8-0.8-1.6c0.4-1.3,1.8-2.1,3-2.4 c1.9-0.5,3.9-0.6,5.8-0.8c2.3-0.2,4.5-0.4,6.8-0.7c1.3-0.1,2.5-1.1,2.5-2.5C87.9,79.3,86.8,77.9,85.4,78L85.4,78z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 94.4,
    y1: 31.9,
    x2: 94.4,
    y2: 47.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 96.4,
    y1: 124.9,
    x2: 96.4,
    y2: 137.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 84.9,
    y1: 138.4,
    x2: 98.4,
    y2: 137.9
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.85 0 0 1 34.4103 60.7074)",
    className: "st1 st2"
  }, "A+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfaction6);
export default __webpack_public_path__ + "static/media/Satisfaction6.3dd6b060938305be55cf1cdb1cc3611b.svg";
export { ForwardRef as ReactComponent };